import moment from 'moment';

import {omitNull} from 'common/utils';

// Max length values for string fields
export const TITLE_MAX_LENGTH = 100;
export const MESSAGE_MAX_LENGTH = 500;

export default class ServiceAnnouncement {
  /* eslint-disable camelcase */
  constructor({
    _id,
    start_time,
    end_time,
    title,
    message,
  }) {
    this._id = _id || btoa(start_time + end_time);
    this.startTime = start_time
      ? moment.utc(start_time)
      : moment.utc();
    this.endTime = end_time
      ? moment.utc(end_time)
      : moment.utc();
    this.title = title || '';
    this.message = message || '';
  }
  /* eslint-enable camelcase */

  get uuid() {
    return this._id;
  }

  clone() {
    return new ServiceAnnouncement(this.serialize());
  }

  serialize() {
    return omitNull({
      _id: this._id,
      start_time: this.startTime.format('Y-MM-DDTHH:mm:ss.SSS[Z]'),
      end_time: this.endTime.format('Y-MM-DDTHH:mm:ss.SSS[Z]'),
      title: this.title,
      message: this.message,
    });
  }
}



// WEBPACK FOOTER //
// ./src/common/types/ServiceAnnouncement.js